import Api from './config';

class SnippetsApi {
    static list(search = '') {
        return Api.request({
            method: 'GET',
            url: `/snippets${search ? `?search=${encodeURIComponent(search)}` : ''}`
        });
    }

    static get(id) {
        return Api.request({
            method: 'GET',
            url: `/snippets/${id}`
        });
    }

    static create(data) {
        return Api.request({
            method: 'POST',
            url: '/snippets',
            data
        });
    }

    static update(id, data) {
        return Api.request({
            method: 'PUT',
            url: `/snippets/${id}`,
            data
        });
    }

    static delete(id) {
        return Api.request({
            method: 'DELETE',
            url: `/snippets/${id}`
        });
    }

    static copy(id) {
        return Api.request({
            method: 'POST',
            url: `/snippets/${id}/copy`
        });
    }

    static changeActive(id) {
        return Api.request({
            method: 'PUT',
            url: `/snippets/${id}/change-active`
        });
    }

    static removePractitioner(snippetId, practitionerId) {
        return Api.request({
            method: 'DELETE',
            url: `/snippets/${snippetId}/practitioners/${practitionerId}`
        });
    }
}

export default SnippetsApi;
